/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitReportAssetRequest
 */
export interface MonitReportAssetRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitReportAssetRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitReportAssetRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitReportAssetRequest
     */
    requested_by?: string;
}

/**
 * Check if a given object implements the MonitReportAssetRequest interface.
 */
export function instanceOfMonitReportAssetRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitReportAssetRequestFromJSON(json: any): MonitReportAssetRequest {
    return MonitReportAssetRequestFromJSONTyped(json, false);
}

export function MonitReportAssetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitReportAssetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'requested_by': !exists(json, 'requested_by') ? undefined : json['requested_by'],
    };
}

export function MonitReportAssetRequestToJSON(value?: MonitReportAssetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason': value.reason,
        'status': value.status,
        'requested_by': value.requested_by,
    };
}

